import script from "./BaseTemplateMainSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateMainSection.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateMainSection.vue?vue&type=style&index=0&id=af612902&lang=sass&scoped=true"
import "./BaseTemplateMainSection.vue?vue&type=style&index=1&id=af612902&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af612902"]])

export default __exports__